/* eslint-disable */
require('./airmail-strip')
require('./bg-graph')
require('./briefcase')
require('./business-requirement')
require('./case-studies')
require('./check')
require('./chevron-left')
require('./chevron-right')
require('./close')
require('./conf-speaker')
require('./contact-us')
require('./email')
require('./footer-case-studies')
require('./footer-contact-us')
require('./footer-what-we-do')
require('./footer-who-we-are')
require('./graph-coloured')
require('./home')
require('./icon-apps')
require('./icon-check')
require('./icon-cloud-data')
require('./icon-customer-needs')
require('./icon-cx-ux')
require('./icon-esm')
require('./icon-ideas')
require('./icon-location')
require('./icon-people')
require('./icon-projects')
require('./icon-roi')
require('./icon-team')
require('./linkedin-original')
require('./linkedin')
require('./location')
require('./mail-stamp')
require('./megaphone')
require('./menu')
require('./message-outline')
require('./message')
require('./message1')
require('./node-bg-dark@2x')
require('./node-bg-white')
require('./phone')
require('./pipefish-logo-on-dark')
require('./pipefish-logo-on-light')
require('./pipefish-role-legend')
require('./quote')
require('./scale')
require('./services')
require('./website')
require('./what-we-do')
require('./who-we-are')
